/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedShippingInfoLink_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDetailShipping_user$ref: FragmentReference;
export type PdpSharedDetailShipping_user = {|
  +$fragmentRefs: PdpSharedShippingInfoLink_user$ref,
  +$refType: PdpSharedDetailShipping_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bab6f1fe84d3ad648fb7f6c68a2a933f';
module.exports = node;
